import BaseModel from './BaseModel'

export default class CityModel extends BaseModel {
    get schema() {
        return {
            id: ['id', undefined],
            name: ['name', undefined],
            sort: ['sort', undefined],
        }
    };

    static attributeLabels = {
        id: 'ID',
        name: 'Название',
    }
}
